/**
 * Visual style for an Intentionality Badge chip.
 *
 * Centralised so the Profile Builder, Admin detail drawer, and the
 * Compatibility View all render the same colour treatment.
 *
 * Active state colours:
 *   - "Spiritually Grounded": soft sage background, off-white text
 *     (inclusive, non-denominational tone)
 *   - Everything else:        gold background, navy text
 *
 * Inactive (toggle-off) badges share a transparent / outlined style.
 */

const GOLD = '#C9A84C';
const NAVY = '#1D2D44';
const SAGE_SOFT = 'rgba(94,127,99,0.65)';   // sage at ~65% — feels soft
const OFFWHITE = '#F5F1E6';
const SAGE_OUTLINE = 'rgba(94,127,99,0.55)';

export const badgeStyle = (badge, active) => {
  const isSpiritual = badge === 'Spiritually Grounded';

  if (!active) {
    return {
      backgroundColor: 'transparent',
      color: '#E8E2D2',
      border: `1px solid ${isSpiritual ? SAGE_OUTLINE : 'rgba(255,255,255,0.18)'}`,
      fontWeight: 400,
    };
  }

  if (isSpiritual) {
    return {
      backgroundColor: SAGE_SOFT,
      color: OFFWHITE,
      border: `1px solid ${SAGE_SOFT}`,
      fontWeight: 600,
    };
  }

  return {
    backgroundColor: GOLD,
    color: NAVY,
    border: `1px solid ${GOLD}`,
    fontWeight: 600,
  };
};
